export const SVG_EDITOR_EVENTS = {
    LOAD: 'LOAD',
    FILE_LOADED: 'FILE_LOADED'
}
